import { ReactComponent as EmptyState } from 'assets/images/svg/empty-videos-about-your-brand.svg'
import EmptyStateNoData from 'components/EmptyStateNoData'
import NoDataAvailable from 'components/NoDataAvailable'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

const TOLGEE_PREFIX = 'VideoContent-EmptyStateLive'

export default function EmptyStateLive({ live }) {
  const t = useTranslate()

  if (!live) {
    return null
  }

  if (live?.state === 'finished') {
    return (
      <div className="live-finished-empty-state">
        <EmptyStateNoData
          image={<EmptyState />}
          text={t({
            key: `${TOLGEE_PREFIX}-finishedLive`,
            defaultValue: "We can't collect the number of viewers from the live video at this time.",
          })}
        />
      </div>
    )
  }

  return (
    <NoDataAvailable
      className="coming-soon"
      icon="coming-soon"
      title={t(TOLGEE_GLOBALS.dataComingSoon)}
      message={t(TOLGEE_GLOBALS.noDataAvailable)}
    />
  )
}
